/**
 * FullCalendar Locale 설정
 * 
 * Calendar.jsx에서 분리된 locale 설정들입니다.
 * 한국어, 영어, 프랑스어 커스텀 locale을 제공합니다.
 */

import koLocale from '@fullcalendar/core/locales/ko';
import enLocale from '@fullcalendar/core/locales/en-gb';
import frLocale from '@fullcalendar/core/locales/fr';

/**
 * 24시간 형식 시간 포맷
 */
const timeFormat24h = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
};

/**
 * 커스텀 기본 locale 설정 - "ALLDAY" 텍스트 제거
 */
export const customLocale = {
    code: 'custom',
    allDayText: '',
    noEventsText: 'No events to display',
    moreLinkText: 'more'
};

/**
 * 한국어 locale 커스터마이징
 */
export const customKoLocale = {
    ...koLocale,
    buttonText: {
        today: '오늘',
        month: '월',
        week: '주',
        day: '일',
        list: '목록'
    },
    allDayText: '',
    noEventsText: '표시할 이벤트가 없습니다',
    moreLinkText: '더보기',
    // 월간 뷰에서 '일' 제거
    dayCellContent: (arg) => arg.dayNumberText.replace('일', ''),
    // 24시간 형식 강제
    eventTimeFormat: timeFormat24h,
    slotLabelFormat: timeFormat24h
};

/**
 * 프랑스어 locale 커스터마이징
 */
export const customFrLocale = {
    ...frLocale,
    buttonText: {
        today: 'Auj.',
        month: 'Mois',
        week: 'Sem.',
        day: 'Jour',
        list: 'Liste'
    },
    allDayText: '',
    noEventsText: 'Aucun événement à afficher',
    moreLinkText: 'plus',
    eventTimeFormat: timeFormat24h,
    slotLabelFormat: timeFormat24h
};

/**
 * 영어 locale 커스터마이징
 */
export const customEnLocale = {
    ...enLocale,
    buttonText: {
        today: 'Today',
        month: 'Month',
        week: 'Week',
        day: 'Day',
        list: 'List'
    },
    allDayText: '',
    noEventsText: 'No events to display',
    moreLinkText: 'more',
    eventTimeFormat: timeFormat24h,
    slotLabelFormat: timeFormat24h
};

/**
 * 사용자 언어에 따라 locale 코드 반환
 * @param {string} userLang - 사용자 언어 ('ko', 'en', 'fr')
 * @returns {string} FullCalendar locale 코드
 */
export function getCalendarLocale(userLang) {
    if (userLang === 'fr') return 'fr';
    if (userLang === 'ko') return 'ko';
    return 'en';
}

/**
 * 사용자 언어에 따라 커스텀 locale 객체 반환
 * @param {string} userLang - 사용자 언어 ('ko', 'en', 'fr')
 * @returns {Object} FullCalendar locale 객체
 */
export function getCustomLocale(userLang) {
    switch (userLang) {
        case 'ko':
            return customKoLocale;
        case 'fr':
            return customFrLocale;
        case 'en':
        default:
            return customEnLocale;
    }
}

/**
 * 모든 locale 객체 배열 (FullCalendar locales prop용)
 */
export const allLocales = [customKoLocale, customEnLocale, customFrLocale];
